import React, { useState, useContext } from 'react';
import "../../css/Form.css"
import { AlertContext } from '../../AlertContext';
const InsertForm = ({apiUrl}) => {
  const [formData, setFormData] = useState({
    customerId: '',
    firstname: '',
    lastname: '',
    waterpurifier: '',
    waterpurifier_type: '',
    cost: '',
    date_of_installation: '',
    date_last_service: '',
    description:'',
    contact: '',
    address: '',
  });
  const { showAlert } = useContext(AlertContext);
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const installationDate = new Date(formData.date_of_installation);
    const lastServiceDate = new Date(formData.date_last_service);
    if (lastServiceDate < installationDate) {
      showAlert("Error: Last Service Date cannot be before Installation Date", "danger");
      return;
    }
    const response = await fetch(`${apiUrl}/dashboard/customer/insert`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        customerId: formData.customerId,
        firstname: formData.firstname,
        lastname: formData.lastname,
        waterpurifier: formData.waterpurifier,
        waterpurifier_type: formData.waterpurifier_type,
        cost: formData.cost,
        date_of_installation: formData.date_of_installation,
        date_last_service: formData.date_last_service,
        description:formData.description,
        contact: formData.contact,
        address: formData.address
      })

    })

    if (response.status === 201) {
      showAlert("Inserted Customer Details Successfully", "success")
    }
    else {
      showAlert("Error: Could not insert customer details.. Try again", "danger")
    }

    // Reset form fields after submission if needed
    setFormData({
      customerId: '',
      firstname: '',
      lastname: '',
      waterpurifier: '',
      waterpurifier_type: '',
      cost: '',
      date_of_installation: '',
      date_last_service: '',
      description:'',
      contact: '',
      address: '',
    });
  };

  return (
    <>
      <div className="container">
        <h3>Insert Customer Data:</h3>
        <form onSubmit={handleSubmit} className="form">
          <div className="form-field">
            <label htmlFor="firstname">Customer Id:</label>
            <input type="text" name="customerId" value={formData.customerId} onChange={handleChange} />
          </div>
          <div className="form-field">
            <label htmlFor="firstname">First Name:</label>
            <input type="text" name="firstname" value={formData.firstname} onChange={handleChange} />
          </div>
          <div className="form-field">
            <label htmlFor="lastname">Last Name:</label>
            <input type="text" name="lastname" value={formData.lastname} onChange={handleChange} />
          </div>
          <div className="form-field">
            <label htmlFor="waterpurifier">Water Purifier:</label>
            <input type="text" name="waterpurifier" value={formData.waterpurifier} onChange={handleChange} />
          </div>
          <div className="form-field">
            <label htmlFor="waterpurifier_type">Water Purifier Type:</label>
            <input type="text" name="waterpurifier_type" value={formData.waterpurifier_type} onChange={handleChange} />
          </div>
          <div className="form-field">
            <label htmlFor="cost">Cost:</label>
            <input type="number" name="cost" value={formData.cost} onChange={handleChange} />
          </div>
          <div className="form-field">
            <label htmlFor="date_of_installation">Installation Date:</label>
            <input type="date" name="date_of_installation" value={formData.date_of_installation} onChange={handleChange} />
          </div>
          <div className="form-field">
            <label htmlFor="date_last_service">Last Service Date:</label>
            <input type="date" name="date_last_service" value={formData.date_last_service} onChange={handleChange} />
          </div>
          <div className="form-field">
            <label htmlFor="description">Description:</label>
            <input type="text" name="description" value={formData.description} onChange={handleChange} />
          </div>
          <div className="form-field">
            <label htmlFor="contact">Contact:</label>
            <input type="text" name="contact" value={formData.contact} onChange={handleChange} />
          </div>
          <div className="form-field">
            <label htmlFor="address">Address:</label>
            <textarea name="address" value={formData.address} onChange={handleChange}></textarea>
          </div>
          <div className="button form-filed">
            <button type="submit" className="submit-button">Submit</button>
          </div>
        </form>
      </div>
    </>
  );
};

export default InsertForm;
